import { connectRouter, RouterState } from 'connected-react-router'
import { Action, combineReducers } from 'redux'
import { clearState } from '../../common/auth/authActions'
import { auth, AuthState } from '../../common/auth/authReducer'
import notifications, { NotificationState } from '../../common/notifications/NotificationReducers'
import { activity, ActivityState } from '../../views/Activity/store/ActivityReducer'
import { settings, SettingsState } from '../../views/Settings/store/SettingsReducer'
import { statistics, StatisticsState } from '../../views/Statistics/store/StatisticsReducer'
import { progress, ProgressState } from '../../views/Progress/store/ProgressReducer'
import { userManagement, UserManagementState } from '../../views/UserManagement/store/UserManagementReducer'
import { integration, IntegrationState } from '../../common/integration/integrationReducer'
import { History } from 'history'
import { companyRanking, CompanyRankingState } from '../../views/CompanyRanking/store/CompanyRankingReducer'
import { dashboard, DashboardState } from '../../views/Dashboard/store/DashboardReducer'
import { loading, LoadingState } from '../../common/loading/loadingReducer'
import { teamManagement, TeamManagementState } from '../../views/TeamManagement/store/TeamManagementReducer'
import { login, LoginState } from '../../views/Login/store/LoginReducer'
import { announcements, AnnouncementsState } from '../../views/Announcements/store/AnnouncementsReducer'
import { inbox, InboxState } from '../../views/Inbox/store/InboxReducer'
import { upload, UploadState } from '../../components/YumUpload/store/UploadReducer'
import {
  userPreferences,
  UserPreferencesState,
} from '../../views/NotificationPreferences/store/NotificationPreferencesReducer'
import { registerUser, RegisterUserState } from '../../views/RegisterUser/store/RegisterUserReducer'
import { signUp, SignUpState } from '../../views/SignUp/store/SignUpReducer'
import { challengeAdmin, ChallengeAdminState } from '../../views/ChallengeAdmin/store/ChallengeAdminReducer'
import { ssoAdmin, SsoAdminState } from '../../views/SsoAdmin/store/SsoAdminReducer'
import { domainAdmin, DomainAdminState } from '../../views/DomainAdmin/store/DomainAdminReducer'
import { signUpCodeAdmin, SignUpCodeAdminState } from '../../views/SignUpCodeAdmin/store/SignUpCodeAdminReducer'
import { companyAdmin, CompanyAdminState } from '../../views/CompanyAdmin/store/CompanyAdminReducer'
import { featuresAdmin, FeaturesAdminState } from '../../views/FeaturesAdmin/store/FeaturesAdminReducer'
import { superAdmin, SuperAdminState } from '../../views/SuperAdmin/store/SuperAdminReducer'
import { importUsersAdmin, ImportUsersAdminState } from '../../views/ImportUsersAdmin/store/ImportUsersAdminReducer'
import { importDataAdmin, ImportDataAdminState } from '../../views/ImportDataAdmin/store/ImportDataAdminReducer'
import { verifyEmailReducer, IVerifyEmailState } from '../../views/VerifyEmail/store/VerifyEmailReducer'
import { forgotPasswordReducer, ForgotPasswordState } from '../../views/ForgotPassword/store/ForgotPasswordReducer'

export interface IGlobalState {
  router: RouterState
  auth: AuthState
  login: LoginState
  activity: ActivityState
  userManagement: UserManagementState
  teamManagement: TeamManagementState
  announcements: AnnouncementsState
  inbox: InboxState
  signUp: SignUpState
  registerUser: RegisterUserState
  userPreferences: UserPreferencesState
  settings: SettingsState
  notifications: NotificationState
  statistics: StatisticsState
  dashboard: DashboardState
  progress: ProgressState
  integration: IntegrationState
  companyRanking: CompanyRankingState
  loading: LoadingState
  upload: UploadState
  challengeAdmin: ChallengeAdminState
  ssoAdmin: SsoAdminState
  domainAdmin: DomainAdminState
  signUpCodeAdmin: SignUpCodeAdminState
  companyAdmin: CompanyAdminState
  featuresAdmin: FeaturesAdminState
  superAdmin: SuperAdminState
  importUsersAdmin: ImportUsersAdminState
  importDataAdmin: ImportDataAdminState
  verifyEmail: IVerifyEmailState
  forgotPassword: ForgotPasswordState
}

const combinedReducers = (history: History) =>
  combineReducers({
    auth,
    login,
    userManagement,
    teamManagement,
    announcements,
    inbox,
    signUp,
    registerUser,
    userPreferences,
    activity,
    settings,
    router: connectRouter(history),
    notifications,
    statistics,
    dashboard,
    progress,
    integration,
    companyRanking,
    loading,
    upload,
    challengeAdmin,
    ssoAdmin,
    domainAdmin,
    signUpCodeAdmin,
    companyAdmin,
    featuresAdmin,
    superAdmin,
    importUsersAdmin,
    importDataAdmin,
    verifyEmail: verifyEmailReducer,
    forgotPassword: forgotPasswordReducer,
  })

export const appReducer = (history: any) => (state: IGlobalState, action: Action) => {
  // This empties the entire state on logout.
  if (action.type === String(clearState)) {
    return combinedReducers(history)(undefined, action)
  }

  return combinedReducers(history)(state, action)
}
